import { Request } from 'express';
import { ReactElement } from 'react';
import { TrackPageViewContainer } from '../../../common/containers/TrackPageViewContainer';
import { getDehydratedState } from '../../../common/getDehydrateState';
import { t } from '../../../common/getTranslations';
import { CategoryTypeVo } from '../../../common/shared/api/nicolas/vo/enums/CategoryTypeVo.enum';
import { Layout } from '../../../design-system/layout/Layout';
import PageLayout from '../../../domain/landing/presentational';
import { ApiErrorBoundary } from '../../../errors/ApiErrorBoundary.class';
import { addError } from '../../../errors/ErrorSlice';
import { thunkSerializeError } from '../../../errors/thunkSerializeError.function';
import { StaticLandingDayOfWeekLayoutQuery, StaticLandingDayOfWeekLayoutQueryVariables, StaticLandingDayOfWeekSection, StaticLandingType } from '../../../graphql/generated/types';
import { CommonMobileHeaderType } from '../../../header/constants';
import { PageViewCustomPropsDataKey } from '../../../logging/PageViewCustomPropsDataKey.enum';
import { setLayout } from '../../../pagewebLayout/PagewebLayoutSlice';
import { nextReduxWrapper } from '../../../state/store';
import { STATIC_LANDING_PAGE_NAME_MAP, STATIC_LANDING_PAGE_SECTION_NAME } from '../../../staticLanding/constants';
import { queryStaticLandingLayout } from '../../../staticLanding/queryStaticLandingLayout';
function LandingDayOfWeek({
  layoutId,
  categoryName
}: {
  layoutId: string;
  categoryName: string;
}) {
  return <>
      <ApiErrorBoundary>
        <PageLayout id={layoutId} />
      </ApiErrorBoundary>
      <TrackPageViewContainer trackObj={{
      shouldSendUsagePage: true,
      section: STATIC_LANDING_PAGE_SECTION_NAME,
      page: `${STATIC_LANDING_PAGE_NAME_MAP[StaticLandingType.DayOfWeek]}_${categoryName}`,
      actionType: 'Pageview',
      actionName: `${STATIC_LANDING_PAGE_NAME_MAP[StaticLandingType.DayOfWeek]}_화면`,
      customProps: {
        user_action: 'pv'
      }
    }} customPropsDataKeyList={[PageViewCustomPropsDataKey.PageGenreFilter, PageViewCustomPropsDataKey.PageBmFilter, PageViewCustomPropsDataKey.PageDay]} />
    </>;
}
LandingDayOfWeek.getInitialProps = nextReduxWrapper.getInitialPageProps(store => async context => {
  const cookie = context?.req?.headers.cookie;
  const uidInfoList = context.query?.pathParams as string[];
  const query = context?.query;
  if (!uidInfoList || uidInfoList.length === 0) {
    return {
      notFound: true
    };
  }
  try {
    const {
      data,
      queryClient
    } = await queryStaticLandingLayout<StaticLandingDayOfWeekLayoutQuery, StaticLandingDayOfWeekLayoutQueryVariables>({
      ssrRequest: context.req as Request,
      type: StaticLandingType.DayOfWeek,
      cookie,
      uidInfoList,
      query
    });
    if (!data || !data.staticLandingDayOfWeekLayout) {
      throw new Error('요일연재 고정랜딩 레이아웃 데이터가 없습니다.');
    }
    const layoutId = data.staticLandingDayOfWeekLayout.id;
    // redux에 레이아웃 정보가 없을 때만 setLayout으로 값을 초기화 해줍니다.
    if (!store.getState().pagewebLayout.entities.layouts[layoutId]) {
      store.dispatch(setLayout({
        layout: data.staticLandingDayOfWeekLayout
      }));
    }
    const staticLandingDayOfWeekSection = data.staticLandingDayOfWeekLayout.sections[0] as StaticLandingDayOfWeekSection;
    const categoryUid = staticLandingDayOfWeekSection?.param?.categoryUid;
    return {
      layoutId,
      categoryName: categoryUid === undefined || categoryUid === CategoryTypeVo.Cartoon ? '웹툰' : '웹소설',
      subcategoryName: staticLandingDayOfWeekSection.param.subcategory?.name,
      bmTypeName: staticLandingDayOfWeekSection.param.businessModel?.name,
      dayName: staticLandingDayOfWeekSection.param.dayTab?.name,
      ...getDehydratedState(queryClient)
    };
  } catch (error) {
    // TODO: 초기 페이지 진입 시 API 호출에 실패한 경우에 대한 핸들링 추가가 필요합니다.
    store.dispatch(addError({
      error: thunkSerializeError(error)
    }));
    return {};
  }
});
LandingDayOfWeek.getLayout = function getLayout(page: ReactElement) {
  const {
    subcategoryName,
    bmTypeName,
    dayName
  } = page.props;
  return <Layout title={t('landing_ongoing')} mobileLayoutConfig={{
    shouldShowHeader: true,
    shouldShowFooter: true,
    headerType: CommonMobileHeaderType.TwoDepth,
    headerCustomTiaraObject: {
      customProps: {
        page_genre_filter: subcategoryName,
        page_bm_filter: bmTypeName,
        page_day: dayName
      }
    }
  }} pcLayoutConfig={{
    shouldShowHeader: true,
    shouldShowFooter: true
  }}>
      {page}
    </Layout>;
};
export default LandingDayOfWeek;